import { apiProvider } from "@/services/utilities/Provider";
import { toApiRequest, toUpdateRequest } from "@/services/campaignMapper";

export const CampaignService = {
    getByScenario: (scenarioId, page = 1, pageSize = 20) =>
        apiProvider.get(`/campaign/scenario/${scenarioId}?page=${page}&pageSize=${pageSize}`),
    getById: (id) => apiProvider.get(`/campaign/${id}`),
    getScoringModel: (campaignId) => apiProvider.get(`/campaign/${campaignId}/scoring-model`),
    create: (scenarioId, campaign) =>
        apiProvider.post("campaign", toApiRequest(scenarioId, campaign)),
    update: (campaignId, campaign) =>
        apiProvider.put(`campaign/${campaignId}`, toUpdateRequest(campaign)),
    changeStatus: (campaignId, status) =>
        apiProvider.patch(`campaign/${campaignId}/status`, { status }),
    toggleFavorite: (campaignId) =>
        apiProvider.patch(`campaign/${campaignId}/favorite`, {}),
    getActiveByOwner: (ownerId, page = 1, pageSize = 20) =>
        apiProvider.get(`/campaign/owner/${ownerId}/active?page=${page}&pageSize=${pageSize}`),
    simulate: (campaignId, testContact) =>
        apiProvider.post(`campaign/${campaignId}/simulate`, { testContact }),
    createTestLead: (campaignId) =>
        apiProvider.post(`campaign/${campaignId}/test-lead`, {}),
    getLeadSourceServiceAccountEmail: () =>
        apiProvider.get(`/campaign/lead-source/service-account-email`),
    checkLeadSourceAccess: (spreadsheetUrl, sheetName) =>
        apiProvider.post(`campaign/lead-source/check-access`, { spreadsheetUrl, sheetName }),
    getLeadSourceColumnValues: (spreadsheetUrl, sheetName, columnName) =>
        apiProvider.post(`campaign/lead-source/column-values`, { spreadsheetUrl, sheetName, columnName }),
    // Task-24/26 -- Excel Online (Microsoft Graph), OAuth delegated. Route stays under
    // "lead-source/microsoft-graph" even for Output connections (purpose param routes both) -- see
    // MicrosoftGraphController remarks.
    getMicrosoftGraphAuthorizeUrl: (campaignId, purpose) => {
        // campaignId is optional (unsaved campaigns have none yet) -- omit the param entirely rather
        // than sending an empty string, which fails ASP.NET's Guid query-string binding.
        const query = campaignId ? `campaignId=${campaignId}&purpose=${encodeURIComponent(purpose)}` : `purpose=${encodeURIComponent(purpose)}`;
        return apiProvider.get(`/campaign/lead-source/microsoft-graph/authorize-url?${query}`);
    },
    checkExcelLeadSourceAccess: (fileUrl, worksheetName, connectionId) =>
        apiProvider.post(`campaign/lead-source/excel/check-access`, { fileUrl, worksheetName, connectionId }),
    getExcelLeadSourceColumnValues: (fileUrl, worksheetName, connectionId, columnName) =>
        apiProvider.post(`campaign/lead-source/excel/column-values`, { fileUrl, worksheetName, connectionId, columnName }),
    importLeadsFromSource: (campaignId) =>
        apiProvider.post(`campaign/${campaignId}/lead-source/import`, {}),
    runOutputForLeads: (campaignId, leadIds) =>
        apiProvider.post(`campaign/${campaignId}/output/run`, { leadIds }),
    uploadProductAttachments: (files = []) => {
        const formData = new FormData();
        files.forEach((f) => formData.append("files", f));
        return apiProvider.postMultipart(`campaign/attachments/upload`, formData);
    },
};
